import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageAttachment: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="page-attachment"><path d="M11.75 2.75H19.25V21.25H4.75V14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.75 7.75V4.25C5.75 3.42157 6.42157 2.75 7.25 2.75C8.07843 2.75 8.75 3.42157 8.75 4.25V8.75C8.75 10.4069 7.40685 11.75 5.75 11.75C4.09315 11.75 2.75 10.4069 2.75 8.75V4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPageAttachment;
